"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var Profile = function (_a) {
    var _b = _a.color, color = _b === void 0 ? helios_styles_1.brand.primary : _b, _c = _a.size, size = _c === void 0 ? 56 : _c;
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 56 56", fill: "none" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: color, fillRule: "evenodd", d: "M37.304 23.71a9.3 9.3 0 0 1-4.683 8.076 16.74 16.74 0 0 1 10.195 8.346 1 1 0 1 1-1.774.924C38.591 36.349 33.67 33.139 28 33.139s-10.591 3.21-13.042 7.917a1 1 0 0 1-1.774-.924 16.74 16.74 0 0 1 10.195-8.346 9.304 9.304 0 1 1 13.925-8.076M28 31.014a7.304 7.304 0 1 0 0-14.608 7.304 7.304 0 0 0 0 14.608", clipRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { fill: color, fillRule: "evenodd", d: "M53 28c0 13.807-11.193 25-25 25S3 41.807 3 28 14.193 3 28 3s25 11.193 25 25m-2 0c0 12.703-10.297 23-23 23S5 40.703 5 28 15.298 5 28 5s23 10.298 23 23", clipRule: "evenodd" })] })));
};
exports.Profile = Profile;
